import { apolloSpaceInlineHalfX, apolloSpaceInline1X, apolloSpaceInline2X, apolloSpaceInline3X, apolloSpaceInline4X, apolloSpaceInline5X, apolloSpaceInline6X, } from "@nexthink/apollo-tokens";
export const space = [
    apolloSpaceInlineHalfX,
    apolloSpaceInline1X,
    apolloSpaceInline2X,
    apolloSpaceInline3X,
    apolloSpaceInline4X,
    apolloSpaceInline5X,
    apolloSpaceInline6X,
];
//# sourceMappingURL=Space.js.map